import React, {memo} from "react"
import filterVariantList from "../filterVariantList";
import ThemeElement from "../../theme/ThemeElement";


export default function GeneralFormView({name, list, selected, variants, className = ''}) {
    return {
        name: name,
        label: `Select ${name.replace(/_/g, ' ')}`,
        placeholder: `Select ${name}`,
        type: "Module",
        module: SelectGeneral,
        list: list?.map((item) => ({
            label: item.label,
            value: item.label,
        })),
        variants: variants,
        clear: false,
        reset: false,
        defaultValue: selected || Object.keys(list)[0],
        className: className,
    }
}


const SelectGeneral = memo(({item, submit, data}) => {
    const formData = data;
    const availableList = item?.list?.sort((a, b) => a.label.localeCompare(b.label)).map(general=> {
        const variants = filterVariantList(item.variants, {...data, [item.name]: general.label})
        return ({
            ...general,
            //disabled: variants.length === 0
        })
    })
    
    
    
    const name = `Form_${item.name}`
    
    return (
        <ThemeElement
            name={name}
            data={{
                list : availableList,
                formData:formData,
                submit:submit,
                item:item,
            }}
        />
    
    )
})

